import { render, staticRenderFns } from "./promotional-discounts-edit.vue?vue&type=template&id=2ab5d732&scoped=true"
import script from "./promotional-discounts-edit.vue?vue&type=script&lang=js"
export * from "./promotional-discounts-edit.vue?vue&type=script&lang=js"
import style0 from "./promotional-discounts-edit.vue?vue&type=style&index=0&id=2ab5d732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab5d732",
  null
  
)

export default component.exports